import { Spinner } from "@blueprintjs/core"
import NoResults from "components/Organisms/NoResults"
import { useTripRecommendations } from "graphql/trip/trip.hooks"
import React from "react"
import RecommendationCard from "./RecommendationCard"

const Recommendations = () => {
  const { data, loading, error } = useTripRecommendations()

  if (loading) return <Spinner />

  return (
    <div className="vt-recomendations">
      {error ? (
        <NoResults
          title="No Recommendations"
          description="Coudn't load the recommendations"
        />
      ) : null}
      {data?.map(r => {
        return <RecommendationCard key={r?.id} plotCommodity={r} />
      })}
    </div>
  )
}

export default Recommendations
